<template>
  <div class="grower-calculator">
    <GrowerCalculator
      :valueCalculator="valueCalculator"
      :backgroundTheme="backgroundTheme"
      :brand="brand"
    />
  </div>
</template>
<script>
import GrowerCalculator from '@/components/GrowerCalculator';

export default {
  components: {
    GrowerCalculator
  },
  data() {
    return {
      backgroundTheme: 'light',
      brand: 'aspire',
      valueCalculator: {
        contentType: 'valueCalculator',
        id: '2MFAlombLKw8rBIHfcDfjj',
        title: "Calculate What You're Missing",
        description: "If you are using a commodity blend, you're leaving money on the table.",
        fertilizers: [
          {
            contentType: 'valueCalculatorFertilizer',
            id: '2NUmFYTOxJTQk8nuUYBG8O',
            name: 'MOP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '6Z9n3tEpEOrSjUabdNutfj',
              crop: 'Cotton',
              priceUnit: 'lbs lint',
              minimumPrice: 0.5,
              maximumPrice: 1,
              defaultPrice: 0.7,
              priceInterval: 0.01
            },
            yieldUnit: 'acre',
            minimumYield: 50,
            maximumYield: 160,
            defaultYield: 105,
            yieldInterval: 1,
            cost: 10,
            disclaimer:
              '*Results based on 200 lbs of Aspire applied and a premium of $100/ton over MOP. This example reflects typical use rates. Actual yield results and local pricing may vary.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '6gnBpiIv25LTZWAPfmkEWy',
            name: 'MOP + Granular B',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '6Z9n3tEpEOrSjUabdNutfj',
              crop: 'Cotton',
              priceUnit: 'lbs lint',
              minimumPrice: 0.5,
              maximumPrice: 1,
              defaultPrice: 0.7,
              priceInterval: 0.01
            },
            yieldUnit: 'acre',
            minimumYield: 15,
            maximumYield: 55,
            defaultYield: 33,
            yieldInterval: 5,
            cost: 4.75,
            disclaimer:
              '*Yield response of 33 lbs/Ac over MOP + Granular B treatment based on results obtained in the AgriFacts below. Results based on 200 lbs of Aspire applied and a premium of $100/ton over MOP with a granular B source applied at 1 lb B/Ac at an estimated cost of $5.25/Ac. This example reflects typical use rates. Actual yield results and local pricing may vary.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '4Iyhlc27lbRlJVtBDVgFym',
            name: 'MOP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '4nkB0AXEMO6o3sSDimDyO2',
              crop: 'Corn',
              priceUnit: 'bu',
              minimumPrice: 2.5,
              maximumPrice: 8.5,
              defaultPrice: 5,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1.8,
            maximumYield: 10,
            defaultYield: 5,
            yieldInterval: 0.1,
            cost: 5.75,
            disclaimer:
              '*Results based on 100 lbs of Aspire applied and a premium of $100/ton over MOP. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: 'YxIwKyl5lKzTN7U5hUFHp',
            name: 'MOP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '6Cj70AUIqKhc0an9mh2Z3O',
              crop: 'Soybean',
              priceUnit: 'bu',
              minimumPrice: 6,
              maximumPrice: 16,
              defaultPrice: 11,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 4,
            defaultYield: 1.6,
            yieldInterval: 0.1,
            cost: 5.75,
            disclaimer:
              '*Results based on 100 lbs of Aspire applied and a premium of $100/ton over MOP. This example reflects typical use rates. Actual yield results and local pricing may vary.  Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '15Ok7D7PQq4Dc8mm4akMc9',
            name: 'MOP + Granular B',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '6Cj70AUIqKhc0an9mh2Z3O',
              crop: 'Soybean',
              priceUnit: 'bu',
              minimumPrice: 6,
              maximumPrice: 16,
              defaultPrice: 11,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 4,
            defaultYield: 1.8,
            yieldInterval: 0.1,
            cost: -0.25,
            disclaimer:
              '*Yield response of 1.8 bu/Ac over MOP + Granular B treatment based on results obtained in the AgriFacts below. Results based on 100 lbs of Aspire applied and a premium of $100/ton over MOP with a granular B source applied at 1.0 lb B/Ac at an estimated cost of $5.25/Ac. This example reflects typical use rates. Actual yield results and local pricing may vary.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '1ncwN5VSu3V3fS3gj23vB1',
            name: 'MOP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1xCYldOk4WisbCxMNFPvFt',
              crop: 'Alfalfa',
              priceUnit: 'ton',
              minimumPrice: 50,
              maximumPrice: 250,
              defaultPrice: 150,
              priceInterval: 5
            },
            yieldUnit: 'acre',
            minimumYield: 0.25,
            maximumYield: 2,
            defaultYield: 0.8,
            yieldInterval: 0.05,
            cost: 20,
            disclaimer:
              '*Results based on 150 lbs of Aspire applied and a premium of $100/ton over MOP. This example reflects typical use rates. Actual yield results and local pricing may vary.  Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '5GoBz24skvysC0pDiiNbRC',
            name: 'MOP + Granular B',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1xCYldOk4WisbCxMNFPvFt',
              crop: 'Alfalfa',
              priceUnit: 'ton',
              minimumPrice: 50,
              maximumPrice: 250,
              defaultPrice: 150,
              priceInterval: 5
            },
            yieldUnit: 'acre',
            minimumYield: 0.1,
            maximumYield: 0.8,
            defaultYield: 0.5,
            yieldInterval: 0.05,
            cost: 9.5,
            disclaimer:
              '*Yield response of 0.50 ton/Ac over MOP + Granular B treatment based on results obtained in the AgriFacts above. Results based on 400 lbs of Aspire applied and a premium of $100/ton over MOP with a granular B source applied at 2 lb B/Ac at an estimated cost of $10.50/Ac. This example reflects typical use rates. Actual yield results and local pricing may vary.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '70T1zTvZgyz3nvDdeL6lh7',
            name: 'MOP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '1y3ce7NobDdfJmcgJUFLFX',
              name: 'Aspire',
              dataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '6b0FwifAhugLzhvdPixJ2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.928Z',
                  updatedAt: '2021-02-28T15:16:15.918Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: '2020 Aspire', file: [Object] }
              },
              description: undefined,
              directionsForUse: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '7tomEXRVu3TDJokDwqxNk1',
                  type: 'Asset',
                  createdAt: '2021-05-05T17:57:55.043Z',
                  updatedAt: '2021-05-05T17:57:55.043Z',
                  environment: [Object],
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'Directions for Use',
                  description: 'Aspire Directions for Use',
                  file: [Object]
                }
              },
              ghsProductLabels: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: 'eTfYdxPXCaLis41AXIYEb',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:41.455Z',
                  updatedAt: '2021-02-07T21:12:57.390Z',
                  environment: [Object],
                  revision: 2,
                  locale: 'en-US'
                },
                fields: { title: 'GHS 114753 Aspire', file: [Object] }
              },
              icon: null,
              logo: {
                id: '4D2oGEZbRMT4T6xHM2mjHo',
                title: 'AspireLogoBlack',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/4D2oGEZbRMT4T6xHM2mjHo/b84bfac9f6e0248517e8d2d4e71f7d0a/AspireLogoBlack.svg',
                contentType: 'image/svg+xml',
                height: 70,
                width: 146
              },
              nitrogen: NaN,
              phosphorus: NaN,
              potassiumOxide: NaN,
              safetyDataSheet: {
                metadata: { tags: [] },
                sys: {
                  space: [Object],
                  id: '2dJ8aSzGiLkBWu8joAhj2H',
                  type: 'Asset',
                  createdAt: '2020-06-29T22:20:39.161Z',
                  updatedAt: '2021-02-08T13:44:29.523Z',
                  environment: [Object],
                  revision: 3,
                  locale: 'en-US'
                },
                fields: { title: 'Aspire SDS', file: [Object] }
              },
              sulfur: NaN,
              sulfate: NaN,
              nutrients: [
                {
                  amount: 0,
                  border: null,
                  symbol: 'N'
                },
                {
                  amount: 0,
                  border: null,
                  symbol: 'P₂O₅'
                },
                {
                  amount: 58,
                  border: null,
                  symbol: 'K₂O'
                },
                {
                  amount: 0.5,
                  border: null,
                  symbol: 'B'
                }
              ],
              slug: undefined,
              specAndSafetyDescription: undefined,
              zinc: NaN
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '6Zu4cGUhWXoLszsswLDEgr',
              crop: 'Potato',
              priceUnit: 'cwt',
              minimumPrice: 7,
              maximumPrice: 16,
              defaultPrice: 10,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 24,
            maximumYield: 50,
            defaultYield: 36,
            yieldInterval: 2,
            cost: 17.25,
            disclaimer:
              '*Yield response of 36 cwt/ac over MOP treatment based on results obtained in the Agrifacts above.  Results based on 310lbs of Aspire applied and a premium of $100/ton over MOP.  This example reflects typical use rates.  Actual yield results and local price may vary.',
            research: [Array],
            phosphorus: undefined,
            nitrogen: undefined
          }
        ]
      }
    };
  }
};
</script>
